import {
  IconButtonProps,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Box,
} from '@mui/material';
import TrainingSetTableRow from './TrainingSetTableRow';
import { ITrainingSet } from '../../types/my-types';

import { useNavigate, useLocation } from 'react-router';

import { standardTableStyles } from '../common/tableStyles';
interface TrainingSetListProps {
  trainingSets: ITrainingSet[];
  count: number;
  page: number;
  perPage: number;
  nextPage: any;
  previousPage: any;
  isFetching: boolean;
  isLoading: boolean;
}

export interface IEBTrainingSetLabels {
  [key: string]: string;
}

function TrainingSetList({
  trainingSets,
  count,
  page,
  perPage,
  nextPage,
  previousPage,
  isFetching,
  isLoading,
}: TrainingSetListProps) {
  const navigate = useNavigate();

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  return (
    <>
      <Box sx={standardTableStyles.containerSx}>
        <Table sx={standardTableStyles.tableSx}>
          <TableHead sx={standardTableStyles.tableHeadSx}>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell align="center">ID</TableCell>
              <TableCell align="center">Language</TableCell>
              <TableCell align="center">Documents</TableCell>
              <TableCell align="center">Trained</TableCell>
              <TableCell align="center">Created</TableCell>
              <TableCell align="center">Updated</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            data-cy="tablebody-training-set-list"
            sx={standardTableStyles.tableBodySx}
          >
            {isLoading
              ? Array.from({ length: 5 }).map((_, i) => (
                  <TableRow key={i}>
                    <TableCell><Skeleton animation="wave" variant="rounded" height={14} width={`${40 + (i * 19) % 45}%`} sx={{ borderRadius: '4px' }} /></TableCell>
                    <TableCell align="center"><Skeleton animation="wave" variant="rounded" height={14} width={80} sx={{ borderRadius: '4px', mx: 'auto' }} /></TableCell>
                    <TableCell align="center"><Skeleton animation="wave" variant="rounded" height={14} width={40} sx={{ borderRadius: '4px', mx: 'auto' }} /></TableCell>
                    <TableCell align="center"><Skeleton animation="wave" variant="rounded" height={14} width={24} sx={{ borderRadius: '4px', mx: 'auto' }} /></TableCell>
                    <TableCell align="center"><Skeleton animation="wave" variant="circular" width={18} height={18} sx={{ mx: 'auto' }} /></TableCell>
                    <TableCell align="center"><Skeleton animation="wave" variant="rounded" height={14} width={72} sx={{ borderRadius: '4px', mx: 'auto' }} /></TableCell>
                    <TableCell align="center"><Skeleton animation="wave" variant="rounded" height={14} width={72} sx={{ borderRadius: '4px', mx: 'auto' }} /></TableCell>
                    <TableCell align="right"><Skeleton animation="wave" variant="rounded" height={14} width={24} sx={{ borderRadius: '4px', ml: 'auto' }} /></TableCell>
                  </TableRow>
                ))
              : null}

            {!isLoading && trainingSets.length > 0
              ? trainingSets?.map((trainingSet: any) => (
                  <TrainingSetTableRow key={trainingSet.id} trainingSet={trainingSet} />
                ))
              : null}

            {trainingSets.length === 0 && !isFetching && !isLoading ? (
              <TableRow>
                <TableCell colSpan={8}>
                  <div style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
                    No Training Sets found
                  </div>
                </TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
        {count > 0 && <TablePagination
          rowsPerPageOptions={[10, 15, 25, 50]}
          component="div"
          count={count}
          rowsPerPage={perPage}
          page={page}
          backIconButtonProps={
            {
              'aria-label': 'Previous Page',
              'data-cy': 'btn-prev-page',
            } as IconButtonProps & { 'data-cy': string }
          }
          nextIconButtonProps={
            {
              'aria-label': 'Next Page',
              'data-cy': 'btn-next-page',
            } as IconButtonProps & { 'data-cy': string }
          }
          onPageChange={(e, p) => {
            e?.preventDefault();
            if (p > page) {
              nextPage();
            } else {
              previousPage();
            }

            searchParams.set('page', p.toString());
            navigate({
              search: searchParams.toString(),
            });
          }}
          onRowsPerPageChange={(e: any) => {
            searchParams.set('perPage', e.target.value);
            navigate({
              search: searchParams.toString(),
            });
          }}
        />}
      </Box>
    </>
  );
}
export default TrainingSetList;
